import React from 'react'
import { Chip } from '@mui/material'

/**
 * Shared CDG cell override for the backend "Reporting" column (`is_report_enabled`,
 * surfaced as `isReportEnabled` after case conversion). The column ships from the
 * backend as TEXT, so the default cell renderer blanks out the boolean value —
 * this override renders a Yes/No badge instead. Used by the Course, Faculty, and
 * Student attribute tables (CE-7).
 *
 * Polarity: only an explicit `false` is hidden. `true`, legacy `null` (grandfathered
 * for backwards compatibility — the backend coerces `null` → `true` on dump), and an
 * absent value all render `Yes`. The rule is `enabled = isReportEnabled !== false`.
 */
interface ReportingCell {
  isReportEnabled?: boolean | null
}

export const reportingColumnOverrides = {
  isReportEnabled: (cell: ReportingCell): JSX.Element => {
    const enabled = cell.isReportEnabled !== false
    return (
      <Chip
        label={enabled ? 'Yes' : 'No'}
        size='small'
        color={enabled ? 'success' : 'default'}
        variant={enabled ? 'filled' : 'outlined'}
      />
    )
  }
}
